import React from 'react';
import './PaymentConfirmation.css';
import { X } from 'lucide-react';

interface PaymentConfirmationProps {
  onClose: () => void;
}

const PaymentConfirmation: React.FC<PaymentConfirmationProps> = ({ onClose }) => {
  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-button6" onClick={onClose}>
          <X size={24} />
        </button>

        <h3 className="modal-title">Thank You for Subscribing!</h3>

        <div className="modal-content">
          <p>We're going live within a month! Cooks are currently preparing their menus.</p>

          <p>
            Since we value your privacy, we can't tell who subscribed before launch. Please send us a screenshot of your subscription with date visible via DM and follow us for updates.
          </p>

          <p>We'll feature you on our page to boost your visibility when we go live.</p>

          <p>Stay tuned for more updates and thank you for being an early supporter of HomeCookt!</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
